import { Radius } from "@faire/slate/foundation/radius";
import { safeToRem } from "@faire/slate/lib/sizeUnitUtils";

import {
  DEFAULT_SKELETON_IMAGE_SIZE,
  DEFAULT_SKELETON_AVATAR_DIAMETER,
  DEFAULT_SKELETON_TITLE_TEXT_WIDTH,
  DEFAULT_SKELETON_TITLE_TEXT_HEIGHT_REM,
  DEFAULT_SKELETON_PARAGRAPH_TEXT_WIDTH,
  DEFAULT_SKELETON_PARAGRAPH_TEXT_HEIGHT_REM,
  DEFAULT_SKELETON_ROUND_WIDTH,
  DEFAULT_SKELETON_ROUND_HEIGHT,
} from "./consts";
import { skeletonVars } from "./SkeletonBase";
import { SkeletonVariant } from "./type";

type IOptions = {
  width?: number | string;
  height?: number | string;
  diameter?: number | string;
  size?: number | string;
};

const getSquareSkeletonVars = (options?: IOptions) => {
  const size = options?.size ?? DEFAULT_SKELETON_IMAGE_SIZE;
  return skeletonVars({
    width: safeToRem(size),
    height: safeToRem(size),
  });
};

const getCircleSkeletonVars = (options?: IOptions) => {
  const size = options?.diameter ?? DEFAULT_SKELETON_AVATAR_DIAMETER;
  return skeletonVars({
    width: safeToRem(size),
    height: safeToRem(size),
    radius: safeToRem(size),
  });
};

const getTitleTextSkeletonVars = (options?: IOptions) =>
  skeletonVars({
    width: safeToRem(options?.width ?? DEFAULT_SKELETON_TITLE_TEXT_WIDTH),
    height: DEFAULT_SKELETON_TITLE_TEXT_HEIGHT_REM,
  });

const getParagraphTextSkeletonVars = (options?: IOptions) =>
  skeletonVars({
    width: safeToRem(options?.width ?? DEFAULT_SKELETON_PARAGRAPH_TEXT_WIDTH),
    height: DEFAULT_SKELETON_PARAGRAPH_TEXT_HEIGHT_REM,
  });

const getRoundSkeletonVars = (options?: IOptions) =>
  skeletonVars({
    width: safeToRem(options?.width ?? DEFAULT_SKELETON_ROUND_WIDTH),
    height: safeToRem(options?.height ?? DEFAULT_SKELETON_ROUND_HEIGHT),
    radius: Radius.component.round,
  });

const getCanvasSkeletonVars = (options?: IOptions) =>
  skeletonVars({
    width: safeToRem(options?.width),
    height: safeToRem(options?.height),
  });

export const getSkeletonVars = (
  variant?: SkeletonVariant,
  options?: IOptions
) => {
  switch (variant) {
    case "square":
      return getSquareSkeletonVars(options);
    case "circle":
      return getCircleSkeletonVars(options);
    case "titleText":
      return getTitleTextSkeletonVars(options);
    case "paragraphText":
      return getParagraphTextSkeletonVars(options);
    case "round":
      return getRoundSkeletonVars(options);
    case "canvas":
    default:
      return getCanvasSkeletonVars(options);
  }
};
